import { render, staticRenderFns } from "./SettingsEmail.vue?vue&type=template&id=1b85b3be&scoped=true&"
import script from "./SettingsEmail.vue?vue&type=script&lang=js&"
export * from "./SettingsEmail.vue?vue&type=script&lang=js&"
import style0 from "./SettingsEmail.vue?vue&type=style&index=0&id=1b85b3be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b85b3be",
  null
  
)

export default component.exports